module.exports = __webpack_public_path__ + "img/pay3.78b9e9b1.png";